import { useCurrentAccount } from '@application/api';
import { CACHE_KEY_BREEDER_STORE_PARTNERSHIP_MODAL_PERSIST_DATE } from '@application/constants';
import { useModal, useRouter } from '@application/utils';
import { MtBreederStorePartnershipModal } from '@presentation/components';
import dayjs from 'dayjs';
import { useEffect } from 'react';

export const BREEDER_STORE_PARTNERSHIP_PERSIST_DAYS = 30;

export const MtBreederStorePartnershipModalController = () => {
  const { show, close, modal } = useModal();
  const { currentAccountLoggedIn, currentAccountType, currentAccount } = useCurrentAccount();
  const { navigateToRoute, language } = useRouter();

  useEffect(() => {
    if (typeof window === 'undefined') return; // Dont' show if server rendered
    if (
      !currentAccountLoggedIn ||
      currentAccountType !== 'breeder' ||
      !currentAccount?.dogBreeder?.certified ||
      language === 'en'
    )
      return;

    let shouldShow = true;
    const timestamp = localStorage.getItem(CACHE_KEY_BREEDER_STORE_PARTNERSHIP_MODAL_PERSIST_DATE);

    if (timestamp) {
      const date = dayjs(Number(timestamp));
      shouldShow = +dayjs() >= +date.add(BREEDER_STORE_PARTNERSHIP_PERSIST_DAYS, 'days'); // Show if currentTime >= PERSIST_TIME + date
    }

    if (!shouldShow) return;

    setTimeout(() => {
      localStorage.setItem(
        CACHE_KEY_BREEDER_STORE_PARTNERSHIP_MODAL_PERSIST_DATE,
        new Date().getTime().toString(),
      );
      show();
    }, 2000);
  }, [
    currentAccount?.dogBreeder?.certified,
    currentAccountLoggedIn,
    currentAccountType,
    language,
    show,
  ]);

  return (
    <MtBreederStorePartnershipModal
      modal={modal}
      onConfirm={() => {
        navigateToRoute('mtAdvantages');
        close();
      }}
    />
  );
};
